import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=01848cb7&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=01848cb7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01848cb7",
  null
  
)

export default component.exports